import React, {useState, useEffect, Fragment} from "react";
import { useFormik } from "formik";
import stateMap from "store/stateMap";
import { connect } from 'react-redux';
import { parsePath } from "history";
import {ReactComponent as SVGArrowUp} from '../../../assets/arrow-up.svg';
import Sidebar from "component/Sidebar";
import BlockHeader from "component/BlockHeader/BlockHeader";
import PaginationWrapper from "component/Pagination";
import { InitiativeList } from "component/InitiativeList";
import { Link } from "react-router-dom";
import _ from "lodash";
import api from "api";
import update from 'immutability-helper';
import './index.scss';
import "./index.scss";
import {ReactComponent as SVGSearch} from './../../../assets/search.svg';
import { PageCredential } from "component/PageCredential";

const PageProfile = connect(stateMap)((props) => {
    

    const [initiatives, setInitiatives]         = useState(false);
    const [countInitiative, setCountInitiative] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;

    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        group           : 'created'
        ,paged          : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 12
        ,type           : queryString.get('type') || ''
        ,initial_letter : queryString.get('initial_letter') || ''
    });

    const formik = useFormik({
        initialValues : {
            search  : ''
            ,type   : ''
            ,sort   : ''
        }
        ,onSubmit : (value) => {
            
            
            setParameter(
                update(parameter, { $apply : function(params){
                    
                    let sorts = value.sort ? value.sort.split(':') : 'Initiative.CreatedDate:DESC'.split(':');
        
                    params.search = value.search;
                    params.sortby = sorts[0] ;
                    params.sort = sorts[1] ;
                    params.type = value.type ;
                    params.paged = 1;
        
                    return _.assign({}, params);
        
                }})
            );

        }
    })

    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    if(toUpdateFilter != 'group')
                    {
                        params[toUpdateFilter] = '';
                    }
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.page = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadInitiative = () => {

        if(dataLoading)
        {
            return;
        }

        let ToSendParameter = {};

        switch(parameter.group)
        {
            case 'created':
                ToSendParameter = _.assignIn({},parameter, {
                    initiator_id : props.auth.user.UserID
                });
                break;
            case 'involved':
                ToSendParameter = _.assignIn({},parameter, {
                    member_id : props.auth.user.UserID
                });
                break;
            case 'done':
                ToSendParameter = _.assignIn({},parameter, {
                    member_id : props.auth.user.UserID
                    ,current_status : 'completed'
                });
                break;
        }

        var DataToLoad = [
            api('/initiative', 'get', ToSendParameter)
        ];

        if(ToSendParameter.paged === 1)
        {
            DataToLoad.push(
                api('/initiative', 'get', _.assign({get_total : 1}, ToSendParameter))
            );
        }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setInitiatives(response[0].initiative);

                if(ToSendParameter.paged === 1)
                {
                    setCountInitiative( parseInt(response[1].initiative) );
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }

    useEffect(loadInitiative, [ parameter]);

    return(
        <>
            <PageCredential title={"Involved Initiatives"}/>
            <div className="profile-initiative-archives container relative">
                <Sidebar>
                    <div className="initiatives-filters filters-boxes">
                        <div className="filter-box">
                            <div className="wrapper">
                                <span className="filter-title">
                                    Initiatives <SVGArrowUp/>
                                </span>
                                <div className="filter-body">
                                    <ul className="filter-items">
                                        <li className={`filter-item ${parameter.group == 'created' && 'active'}`}><a href="#" name="group:created" className="" onClick={changeParams} >Created Initiatives</a></li>
                                        <li className={`filter-item ${parameter.group == 'involved' && 'active'}`}><a href="#" name="group:involved" className="" onClick={changeParams}>Involved Initiatives</a></li>
                                        <li className={`filter-item ${parameter.group == 'done' && 'active'}`}><a href="#" name="group:done" className="" onClick={changeParams}>Initiatives Done</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="filter-box">
                            <div className="wrapper text-center">
                                <Link to="/create" className="btn btn-primary ">Create Initiative</Link>
                            </div>
                        </div>
                    </div>
                </Sidebar>
                <div className="initiative-list-container">
                    { parameter.group == 'created' && <BlockHeader title="Created Initiatives" desc={`${countInitiative ? countInitiative : ''} Initiatives Created`}/> }
                    { parameter.group == 'involved' && <BlockHeader title="Involved Initiatives" desc={`Involves in ${countInitiative ? countInitiative : ''} Initiatives`}/> }
                    { parameter.group == 'done' && <BlockHeader title="Initiatives Done" desc={`${countInitiative ? countInitiative : ''} Initiatives Done`}/> }
                    <hr />
                    <form action="" className="generic-form " onSubmit={formik.handleSubmit}>
                        <div className="field-group">
                            <span className="input-icon-wrapper">
                                <input
                                    value={formik.values.search} onBlur={formik.handleBlur} onChange={formik.handleChange} name="search" 
                                    type="text" className="text form-control rounded" placeholder="Search" />
                                <SVGSearch/>
                            </span>
                        </div>
                        <div className="field-group ">
                            <span className="label block">Type : </span>
                            <div className="fancy-select">
                                <select value={formik.values.type} onBlur={formik.handleBlur} onChange={formik.handleChange} name="type">
                                    <option value="">All</option>
                                    <option value="research">Research</option>
                                    <option value="event">Event</option>
                                    <option value="talent">Talent</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                        </div>
                        <div className="field-group ">
                            <span className="label block">Sort : </span>
                            <div className="fancy-select">
                                <select value={formik.values.sort} onBlur={formik.handleBlur} onChange={formik.handleChange} name="sort">
                                    <option value="">Newest</option>
                                    <option value="Initiative.Title:asc">Alphabet</option>
                                </select>
                            </div>
                        </div>
                        <div className="field-group">
                            <input type="submit" className="btn btn-orange btn-block" value="Search" />
                        </div>
                    </form>
                    <div className="initiatives-list">
                        {
                            initiatives === false ? <span className="skeleton"></span>:
                            (
                                <Fragment>
                                    {
                                        dataLoading ? <div><span className="skeleton"></span></div> :
                                        <>
                                            <InitiativeList initiatives={initiatives}/>
                                            <PaginationWrapper
                                                className="mt-4"
                                                activePage={parameter.paged}
                                                itemsCountPerPage={parameter.posts_per_page}
                                                totalItemsCount={countInitiative}
                                                pageRangeDisplayed={5}
                                                onChange={(pagenumber) => {
                                                    setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                                }}
                                            />
                                        </>
                                    }
                                </Fragment>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )
});

export default PageProfile;